import React, {useEffect, useState} from "react";
import {useGlobalNotificationMessage} from "../../context/message";
import Loading from "../../components/loading";
import Select from "react-select";
import {AppRoles, AppRoleTypes} from "../../utils/constants";
import {userUserGroupRoleRequest} from "../../utils/schemas";
import HelperService from "../../services/helper-service";

export default function UserGroupsUserSelect( {userGroup, usersList, userGroupsList, groupRolesList, selectedUserGroup, onChange=null, ...props} ){
  const {addErrorMessage} = useGlobalNotificationMessage();
  const [internalUserGroupsList, setInternalUserGroupsList] = useState([]);
  const [internalGroupRolesList, setInternalGroupRolesList] = useState([]);
  const [internalUsersList, setInternalUsersList] = useState([]);
  const [internalSelectedUserGroup, setInternalSelectedUserGroup] = useState({});
  const [internalUserGroup, setInternalUserGroup] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(()=>{
    setInternalUserGroup(userGroup);
    setInternalUsersList(!usersList ? [] : usersList.map((g)=>{g.label=g.name; g.value=g.id; return g;}));
    setInternalUserGroupsList(!userGroupsList ? [] : userGroupsList.map((g)=>{g.label=g.title; g.value=g.id; return g;}));
    setInternalGroupRolesList(!groupRolesList ? [] : groupRolesList.filter((g)=>g.type===AppRoleTypes.group).map((g)=>{g.label=g.title; g.value=g.id; return g;}));

    let refreshStateObj = userUserGroupRoleRequest.cast( selectedUserGroup ? selectedUserGroup : {});
    if (!refreshStateObj.role_id && userGroupsList && userGroupsList.length){
      refreshStateObj.role_id = HelperService.getObjByKey(groupRolesList, 'name', AppRoles.groupManager)?.id;
    }
    if (refreshStateObj.role_id){
      refreshStateObj.role = HelperService.getObjByKey(groupRolesList, 'id', refreshStateObj.role_id);
    }
    if (refreshStateObj.user_id){
      refreshStateObj.user = HelperService.getObjByKey(usersList, 'id', refreshStateObj.user_id);
    }
    if (userGroup && userGroup.id){
      refreshStateObj.user_group_id = userGroup.id;
    }
    if (refreshStateObj.user_group_id){
      refreshStateObj.userGroup = HelperService.getObjByKey(userGroupsList, 'id', refreshStateObj.user_group_id);
    }
    setInternalSelectedUserGroup(refreshStateObj);

    if (usersList && groupRolesList && userGroup){
      setLoaded(true);
    }
  }, [selectedUserGroup, userGroupsList, groupRolesList, usersList, userGroup]);

  const selectGroup = (item=null)=>{
    let newObj = userUserGroupRoleRequest.cast({...internalSelectedUserGroup, user_group_id: item ? item.id : null});
    if (onChange && 'function' === typeof onChange){
      setInternalSelectedUserGroup(newObj);
      onChange(newObj);
    }
  };

  const selectUser = (item=null)=>{
    let newObj = userUserGroupRoleRequest.cast({...internalSelectedUserGroup, user_id: item ? item.id : null});
    if (onChange && 'function' === typeof onChange){
      setInternalSelectedUserGroup(newObj);
      onChange(newObj);
    }
  };

  const selectGroupRole = (item=null)=>{
    let newObj = userUserGroupRoleRequest.cast({...internalSelectedUserGroup, role_id: item ? item.id : null});
    if (onChange && 'function' === typeof onChange){
      setInternalSelectedUserGroup(newObj);
      onChange(newObj);
    }
  };

  return (
    <>
      {!loaded || !internalSelectedUserGroup && <Loading className="m-2" />}

      {loaded && internalSelectedUserGroup && <>
        <div className={'row'}>
          {internalUserGroupsList && !(userGroup && userGroup.id) && <>
            <div className={'col'}>
              <Select
                options={internalUserGroupsList}
                placeholder={'Vyberte skupinu'}
                isSearchable
                isClearable
                value={internalSelectedUserGroup.userGroup}
                onChange={selectGroup}
                required="required"
              />
            </div>
          </>}
          <div className={'col'}>
            {internalUsersList && <>
              <Select
                options={internalUsersList}
                placeholder={'Vyberte používatela'}
                isSearchable
                isClearable
                value={internalSelectedUserGroup.user}
                onChange={selectUser}
                required="required"
              />
            </>}
          </div>
          {internalGroupRolesList && internalSelectedUserGroup.user_group_id && <>
            <div className={'col'}>
              <Select
                options={internalGroupRolesList}
                placeholder={'Vyberte skupinovú rolu'}
                isSearchable
                isClearable
                value={internalSelectedUserGroup.role}
                onChange={selectGroupRole}
                required="required"
               />
            </div>
          </>}
        </div>
      </>}
    </>
  );
}
